import { zwClient } from '@/sync/zapworks';
import { prependHttps } from '@/utils';
import { IComponentType } from '@r3f-component-data-structure';
import { IFileType } from '@zappar/zw-api-client';
import { MathUtils } from 'three';
import { IUserActionTypes } from './action-types';
export const onSetActivePreviewTrackingImageIndex = payload => ({
    type: IUserActionTypes.SET_ACTIVE_PREVIEW_TRACKING_IMAGE_INDEX,
    payload
});
export const onSetWhatsNewTrigger = () => ({
    type: IUserActionTypes.SET_WHATS_NEW_TRIGGER
});
export const onSetPublishTrigger = (payload) => ({
    type: IUserActionTypes.SET_PUBLISH_TRIGGER,
    payload
});
export const onTriggerUpdateTrigger = (payload) => ({
    type: IUserActionTypes.SET_UPDATE_TRIGGER,
    payload
});
export const onSetPublishBtnStatus = (payload) => ({
    type: IUserActionTypes.SET_PUBLISH_BTN_STATUS,
    payload
});
export const onSetPreviewBtnStatus = (payload) => ({
    type: IUserActionTypes.SET_PREVIEW_BTN_STATUS,
    payload
});
export const onSetAppClipsConverted = (payload) => ({
    type: IUserActionTypes.SET_APP_CLIPS_CONVERTED,
    payload
});
export const onSetShowPublishPopup = (payload) => ({
    type: IUserActionTypes.SET_SHOW_PUBLISH_POPUP,
    payload
});
export const onSetActiveEditingActionData = (payload) => ({
    type: IUserActionTypes.SET_ACTIVE_EDITING_ACTION_DATA,
    payload
});
export const onSetChromaKeyModalData = (payload) => ({
    type: IUserActionTypes.SET_CHROMA_KEY_EDIT_MODAL_DATA,
    payload,
});
export const onSetSelectedTemplateProject = (payload) => ({
    type: IUserActionTypes.SET_SELECTED_TEMPLATE_PROJECT,
    payload,
});
export const onSetActiveAnimationPreset = (payload) => ({
    type: IUserActionTypes.SET_ACTIVE_ANIMATION_PRESET,
    payload
});
export const onSetPreviewCodeSrc = (payload) => ({
    type: IUserActionTypes.SET_PREVIEW_CODE_SRC,
    payload,
});
export const onSetPreviewUrl = (payload) => ({
    type: IUserActionTypes.SET_PREVIEW_URL,
    payload
});
export const onSetTargetImageReferenceObjectPosition = (payload) => ({
    type: IUserActionTypes.SET_TARGET_IMAGE_REFERENCE_OBJECT_POSITION,
    payload,
});
export const onSetVideoProgress = (payload) => ({
    type: IUserActionTypes.SET_VIDEO_RENDITION_PROGRESS,
    payload
});
export const onSetPopOutIdealTopPosition = (payload) => ({
    type: IUserActionTypes.SET_POPOUT_IDEAL_TOP_POSITION,
    payload
});
export const onOpenModal = (payload) => ({
    type: IUserActionTypes.OPEN_MODAL,
    payload,
});
export const onCloseModal = () => ({
    type: IUserActionTypes.CLOSE_MODAL,
});
export const onSetShowAppClipsModal = (payload) => ({
    type: IUserActionTypes.SET_SHOW_APP_CLIPS_MODAL,
    payload
});
export const onSetEmitterIsStatic = (payload) => ({
    type: IUserActionTypes.SET_EMITTER_IS_STATIC,
    payload,
});
export const onSetPositions = (payload) => ({
    type: IUserActionTypes.SET_POSITIONS,
    payload,
});
export const onSetCurvatures = (payload) => ({
    type: IUserActionTypes.SET_CURVATURES,
    payload,
});
export const onSetRotations = (payload) => ({
    type: IUserActionTypes.SET_ROTATIONS,
    payload,
});
export const onSetScales = (payload) => ({
    type: IUserActionTypes.SET_SCALES,
    payload,
});
export const onSetEmitterAreaScales = (payload) => ({
    type: IUserActionTypes.SET_EMITTER_AREA_SCALES,
    payload,
});
export const onSetFillRgba = (payload) => ({
    type: IUserActionTypes.SET_FILL_RGBA,
    payload,
});
export const onSetFontRgba = (payload) => ({
    type: IUserActionTypes.SET_FONT_RGBA,
    payload,
});
export const onSetBorderRgba = (payload) => ({
    type: IUserActionTypes.SET_BORDER_RGBA,
    payload,
});
export const onSetReplaceEntityMode = (replaceEntityMode) => ({
    type: IUserActionTypes.SET_REPLACE_ENTITY_MODE,
    payload: { replaceEntityMode },
});
export const onSetMultipleEntitySelectBoundary = (payload) => ({
    type: IUserActionTypes.SET_MULTIPLE_ENTITY_SELECT_BOUNDARY,
    payload
});
export const onSetActiveFaceLandmark = (payload) => ({
    type: IUserActionTypes.SET_ACTIVE_FACE_LANDMARK,
    payload,
});
export const onSetTempAnimateModelAction = (action) => ({
    type: IUserActionTypes.SET_TEMP_ANIMATE_MODEL_ACTION,
    payload: { action },
});
export const onSetVisibleCanvas = (canvasName, visible) => ({
    type: IUserActionTypes.SET_VISIBLE_CANVAS,
    payload: { canvasName, visible },
});
export const onSetFileVerifying = (isVerifying) => ({
    type: IUserActionTypes.SET_FILE_VERIFYING,
    payload: { isVerifying },
});
export const onSetOpenInspectorMenuEntityShelf = (payload) => ({
    type: IUserActionTypes.SET_OPEN_INSPECTOR_MENU_ENTITY_SHELF,
    payload,
});
export const onSetOpenInspectorMenuProjectShelf = (payload) => ({
    type: IUserActionTypes.SET_OPEN_PROJECT_MENU_DRAWER,
    payload,
});
export const onSetOpenEntityMenuCategoryDrawer = (openEntityCategoryDrawerDict) => ({
    type: IUserActionTypes.SET_OPEN_ENTITY_MENU_CATEGORY_DRAWER,
    payload: { openEntityCategoryDrawerDict },
});
export const onSetOpenEntityMenuDrawer = (openEntityMenuDrawer) => ({
    type: IUserActionTypes.SET_OPEN_ENTITY_MENU_DRAWER,
    payload: { openEntityMenuDrawer },
});
export const onSetScreenRelativeDevice = (deviceType) => ({
    type: IUserActionTypes.SET_SCREEN_RELATIVE_DEVICE,
    payload: deviceType,
});
export const onSetScreenRelativeDevicePreviousCustomDimensions = (dimensions) => ({
    type: IUserActionTypes.SET_SCREEN_RELATIVE_DEVICE_PREVIOUS_CUSTOM_DIMENSIONS,
    payload: dimensions,
});
export const onSetUserId = (userId) => ({
    type: IUserActionTypes.SET_USER_ID,
    payload: { userId },
});
export const onUpdateUsers = (payload) => ({
    type: IUserActionTypes.UPDATE_USERS,
    payload,
});
export const onSetHotKey = (hotKey) => ({
    type: IUserActionTypes.SET_HOTKEY,
    payload: { hotKey },
});
export const onSetCanvasLoaded = (payload) => ({
    type: IUserActionTypes.CANVAS_IS_LOADED,
    payload,
});
export const onSetActiveScene = (activeSceneProps) => ({
    type: IUserActionTypes.SET_ACTIVE_SCENE,
    payload: activeSceneProps,
});
export const onSetCurrentSceneIndex = (index) => ({
    type: IUserActionTypes.SET_CURRENT_SCENE_INDEX,
    payload: index,
});
export const onScrollSceneMenu = (scrollMenuScene) => ({
    type: IUserActionTypes.SCROLL_SCENE_MENU,
    payload: scrollMenuScene,
});
export const onSetSceneSnapshots = (sceneSnapshotsDict) => ({
    type: IUserActionTypes.SET_SCENE_SNAPSHOTS,
    payload: sceneSnapshotsDict,
});
export const onRemoveHotKey = (hotKey) => ({
    type: IUserActionTypes.REMOVE_HOTKEY,
    payload: { hotKey },
});
export const onSetPositioningIsActive = (payload) => ({
    type: IUserActionTypes.SET_POSITIONING_ACTIVE,
    payload,
});
export const onSetRotationIsActive = (payload) => ({
    type: IUserActionTypes.SET_ROTATION_ACTIVE,
    payload,
});
export const onSetScaleHotSpotEnabled = (scaleHotspotIsEnabled) => ({
    type: IUserActionTypes.SET_SCALE_HOTSPOT_ENABLED,
    payload: scaleHotspotIsEnabled,
});
export const onSetBackgroundHotSpotEnabled = (backgroundHotspotIsEnabled) => ({
    type: IUserActionTypes.SET_BACKGROUND_HOTSPOT_ENABLED,
    payload: backgroundHotspotIsEnabled,
});
export const onSetPureReactInCanvasHovered = (payload) => ({
    type: IUserActionTypes.SET_PURE_REACT_IN_CANVAS_HOVERED,
    payload,
});
export const onAddEntityIdsToSelection = (entityIds) => ({
    type: IUserActionTypes.ADD_ENTITY_IDS_TO_SELECTION,
    payload: entityIds,
});
export const onRemoveSelection = (entityIds) => ({
    type: IUserActionTypes.REMOVE_SELECTION,
    payload: entityIds,
});
export const onChangeZoomLevel = (zoomLevel) => ({
    type: IUserActionTypes.CHANGE_ZOOM_LEVEL,
    payload: zoomLevel,
});
export const onSetPointerOffset = (pointerOffset) => ({
    type: IUserActionTypes.SET_CLICK_OFFSET,
    payload: pointerOffset,
});
export const onSetMarkerIndexPressed = (markerIndex) => ({
    type: IUserActionTypes.SET_MARKER_INDEX_PRESSED,
    payload: markerIndex,
});
export const onSetGroupInversion = (axisInversion) => ({
    type: IUserActionTypes.SET_GROUP_INVERSION,
    payload: axisInversion,
});
export const onCopySelectedEntities = (selectedIds) => ({
    type: IUserActionTypes.COPY_SELECTED_ENTITIES,
    payload: selectedIds,
});
export const onSetSceneEntityListVisible = (isVisibleProps) => ({
    type: IUserActionTypes.SET_SCENE_ENTITY_LIST_VISIBLE,
    payload: isVisibleProps,
});
// export const onSetSnapshotDict: IOnSetSnapshotDict = snapshotDict => ({
// 	type: IUserActionTypes.SET_SNAPSHOT_DICT,
// 	payload: snapshotDict,
// });
export const onSetSceneCarouselScrollLeft = (scrollLeft) => ({
    type: IUserActionTypes.SET_SCENE_CAROUSEL_SCROLL_LEFT,
    payload: scrollLeft,
});
export const onFocusSceneNameInput = (boolean) => ({
    type: IUserActionTypes.FOCUS_SCENE_NAME_INPUT,
    payload: boolean,
});
export const onSetEnlargeSceneMenu = (boolean) => ({
    type: IUserActionTypes.SET_SCENE_MENU_LARGE,
    payload: boolean,
});
export const onEditSceneTitle = (boolean) => ({
    type: IUserActionTypes.EDIT_SCENE_TITLE,
    payload: boolean,
});
export const onSetEntityMenuDragActive = (boolean) => ({
    type: IUserActionTypes.SET_ENTITY_MENU_DRAG_ACTIVE,
    payload: boolean,
});
export const onSetEntityMenuHotspotDragPosition = (payload) => ({
    type: IUserActionTypes.SET_ENTITY_MENU_DRAG_HOTSPOT_POSITION,
    payload,
});
export const onSetDraggedEntityInfo = (payload) => ({
    type: IUserActionTypes.SET_ENTITY_MENU_DRAG_INFO,
    payload,
});
export const onSetLoadingMedia = (payload) => ({
    type: IUserActionTypes.LOADING_MEDIA,
    payload,
});
export const onAddToLoadedAudio = (payload) => ({
    type: IUserActionTypes.ADD_TO_LOADED_AUDIO,
    payload,
});
export const onRemoveUpload = (payload) => ({
    type: IUserActionTypes.REMOVE_UPLOAD,
    payload,
});
export const onSetCurrentUploads = (id, progress) => ({
    type: IUserActionTypes.SET_CURRENT_UPLOADS,
    payload: { id, progress },
});
export const onSetProjectInfo = (payload) => ({
    type: IUserActionTypes.SET_PROJECT_INFO,
    payload,
});
export const onSetAudioStatus = (payload) => ({
    type: IUserActionTypes.SET_AUDIO_STATUS,
    payload,
});
export const setTrkImgIsUploading = (payload) => ({
    type: IUserActionTypes.SET_TRACKING_IMG_UPLOADING,
    payload,
});
export const onSetTrackingImageData = (payload) => ({
    type: IUserActionTypes.SET_TRACKING_IMG_DATA,
    payload,
});
export const onRemoveTrackingImageData = () => ({
    type: IUserActionTypes.REMOVE_TRACKING_IMG_DATA,
});
export const onAddToast = (payload) => ({
    type: IUserActionTypes.ADD_TOAST,
    payload,
});
export const onRemoveToast = (payload) => ({
    type: IUserActionTypes.REMOVE_TOAST,
    payload,
});
export const onSetIs3dMode = (boolean) => ({
    type: IUserActionTypes.SET_3D_MODE,
    payload: boolean,
});
export const onSetIsScreenRelativeMode = (boolean) => ({
    type: IUserActionTypes.SET_SCREEN_RELATIVE_MODE,
    payload: boolean,
});
export const onSetTransformControlsActive = (boolean) => ({
    type: IUserActionTypes.SET_TRANSFORM_CONTROLS_ACTIVE,
    payload: boolean,
});
export const onSetTransformControlsMode = (payload) => ({
    type: IUserActionTypes.SET_TRANSFORM_CONTROLS_MODE,
    payload,
});
export const onSetDragControlsUpdateTrigger = (payload) => ({
    type: IUserActionTypes.SET_DRAG_CONTROLS_UPDATE_TRIGGER,
    payload,
});
export const onSetTemporaryInitialDragRotation = (payload) => ({
    type: IUserActionTypes.SET_TEMP_INITIAL_ROTATION,
    payload,
});
export const onSetMediaLibraryDisplay = (payload) => ({
    type: IUserActionTypes.SET_MEDIA_LIBRARY_DISPLAY,
    payload,
});
export const onSetSelectedAudio = (payload) => ({
    type: IUserActionTypes.SET_SELECTED_AUDIO,
    payload,
});
export const onSetShowFacelandmarks = (payload) => ({
    type: IUserActionTypes.SET_SHOW_FACE_LANDMARKS,
    payload,
});
export const onSetDropdownHoveredFacelandmark = (payload) => ({
    type: IUserActionTypes.SET_HOVERED_FACE_LANDMARK_DROPDOWN,
    payload,
});
export const onSetProjectSizeLimit = (payload) => ({
    type: IUserActionTypes.SET_PROJECT_SIZE_LIMIT,
    payload,
});
export const onSetProjectSize = (payload) => ({
    type: IUserActionTypes.SET_PROJECT_SIZE,
    payload,
});
export const onSetDragSpinnerCoordinates = (payload) => {
    return {
        type: IUserActionTypes.SET_SPINNER_COORDINATES,
        payload,
    };
};
export const onSetLaunchPageIconFilestoreId = (payload) => ({
    type: IUserActionTypes.SET_LAUNCH_PAGE_ICON_FILESTORE_ID,
    payload: payload
});
export const componentToFileType = (componentType) => {
    switch (componentType) {
        case IComponentType.Video:
            return IFileType.StreamingVideo;
        case IComponentType.Model3d:
            return IFileType.Model3D;
        case IComponentType.Image:
        default:
            return IFileType.Image;
    }
};
// export const onGetAudioFileInfo: IOnGetAudioFileInfo = ({limit}) => {
// 	return async (dispatch: Dispatch) => {
// 		if (!zwClient.zml) return;
// 		const audioData = await zwClient.zml.search([IFileType.Audio], undefined, undefined, limit);
// 		const audioInfoArray: IAudio[] = audioData.results.map((audio) => {
// 			return {
// 				id: MathUtils.generateUUID(),
// 				zmlFileId: audio.id,
// 				url: prependHttps(appendMp3(audio.url)),
// 				name: audio.caption,
// 			};
// 		});
// 		dispatch<ISetLoadedAudioAction>({
// 			type: IUserActionTypes.SET_LOADED_AUDIO,
// 			payload: audioInfoArray,
// 		});
// 		dispatch({
// 			type: IUserActionTypes.LOADING_MEDIA,
// 			payload: false,
// 		});
// 	};
// };
export const onGet360BackgroundFileInfo = ({ limit }) => {
    return async (dispatch) => {
        if (!zwClient.zml)
            return;
        const backgroundData = await zwClient.zml.search([IFileType.Image360, IFileType.Video360], undefined, undefined, limit);
        const backgroundContentArray = backgroundData.results.map((asset) => {
            return {
                id: MathUtils.generateUUID(),
                type: asset.type,
                zmlFileId: asset.id,
                url: prependHttps(asset.url),
                name: asset.caption,
                statusUrl: asset.statusURL
            };
        });
        dispatch({
            type: IUserActionTypes.SET_LOADED_360_BACKGROUND,
            payload: backgroundContentArray,
        });
        dispatch({
            type: IUserActionTypes.LOADING_MEDIA,
            payload: false,
        });
    };
};
